export default { sha: '3566f7e6c65cf0289a6ea557d3a3342f6e6403f7', buildNumber: 'undefined' }
